module.exports = __webpack_public_path__ + "static/subscriptions_reasons_3-7ccc191f5d7c63db7edf30a830414e47.svg";